"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var list_item_1 = require("./list-item");
var NAME = 'bullet_list';
var BulletList = /** @class */ (function (_super) {
    __extends(BulletList, _super);
    function BulletList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.content = "(" + list_item_1.LIST_ITEM_NAME + "|" + NAME + ")+";
        _this.role = 'list';
        _this.tagName = function () { return 'ul'; };
        _this.parseDOM = [
            {
                tag: 'ul'
            }
        ];
        _this.textMatcher = [
            {
                matcher: [/^-\s$/, /^\*\s$/]
            }
        ];
        return _this;
    }
    return BulletList;
}(core_utilities_1.Block));
exports.BulletList = BulletList;
var BulletListController = /** @class */ (function (_super) {
    __extends(BulletListController, _super);
    function BulletListController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'bullet_list',
            tooltip: 'bullet_list'
        };
        return _this;
    }
    return BulletListController;
}(core_utilities_1.SylController));
exports.BulletListController = BulletListController;
var BulletListPlugin = /** @class */ (function (_super) {
    __extends(BulletListPlugin, _super);
    function BulletListPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = BulletListController;
        _this.Schema = BulletList;
        return _this;
    }
    return BulletListPlugin;
}(core_utilities_1.SylPlugin));
exports.BulletListPlugin = BulletListPlugin;
//# sourceMappingURL=bullet-list.js.map